var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrossFail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 68,
    viewBox: "0 0 100 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 55.4548C60.5436 55.4548 69.0909 46.9075 69.0909 36.3639C69.0909 25.8202 60.5436 17.2729 50 17.2729C39.4564 17.2729 30.9091 25.8202 30.9091 36.3639C30.9091 46.9075 39.4564 55.4548 50 55.4548Z",
    fill: "#CC0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 29.5L58 44.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58 29.5L43 44.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrossFail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cross-fail.40b49f87a5c15171c10ad42d9bd26087.svg";